import { render, staticRenderFns } from "./RuleAdminApprovalDropDown.vue?vue&type=template&id=226333ad&scoped=true"
import script from "./RuleAdminApprovalDropDown.vue?vue&type=script&lang=js"
export * from "./RuleAdminApprovalDropDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226333ad",
  null
  
)

export default component.exports